/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_SkipInputs */

const en_us2_intake_skip = /** @type {(inputs: Intake_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip this one`)
};

const pt_br2_intake_skip = /** @type {(inputs: Intake_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pular esta`)
};

const es_419_intake_skip = /** @type {(inputs: Intake_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omitir esta`)
};

const pt_pt2_intake_skip = /** @type {(inputs: Intake_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltar esta`)
};

const fr_fr2_intake_skip = /** @type {(inputs: Intake_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer`)
};

const de_de2_intake_skip = /** @type {(inputs: Intake_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese überspringen`)
};

const it_it2_intake_skip = /** @type {(inputs: Intake_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salta questa`)
};

/**
* | output |
* | --- |
* | "Skip this one" |
*
* @param {Intake_SkipInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_skip = /** @type {((inputs?: Intake_SkipInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_SkipInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_skip(inputs)
	if (locale === "es-419") return es_419_intake_skip(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_skip(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_skip(inputs)
	if (locale === "de-DE") return de_de2_intake_skip(inputs)
	if (locale === "it-IT") return it_it2_intake_skip(inputs)
	return en_us2_intake_skip(inputs)
});
export { intake_skip as "intake.skip" }